import React, { useEffect, useState } from "react";
import { FaGripLinesVertical } from "react-icons/fa";

const TableColumnResizer = ({  width, height = 30, onResize,  }) => {
    const [currentWidth, setCurrentWidth] = useState(width);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startWidth, setStartWidth] = useState(0); // Store the initial width

    useEffect(() => {
        if (!isResizing) {
            setCurrentWidth(width);
        }
    }, [width]);

    const handleMouseDown = (e) => {
        setIsResizing(true);
        setStartX(e.clientX);
        setStartWidth(currentWidth); // Remember the width when we started dragging
        e.preventDefault();
    };

    const handleMouseMove = (e) => {
         e.stopPropagation();

        const deltaX = e.clientX - startX;
        const newWidth = Math.max(50, startWidth + deltaX); // Use startWidth, not currentWidth
        setCurrentWidth(newWidth);

        if (onResize) {
            onResize(e, { size: { width: newWidth, height } });
        }
    };

    const handleMouseUp = (e) => {
         e.preventDefault();
        setIsResizing(false);
    };

    React.useEffect(() => {
        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);

            return () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);
            };
        }
    }, [isResizing, startX, startWidth]); // Changed dependency from currentWidth to startWidth

    return (
        // <div style={{
        //     position:'absolute'
        // }}>

        <div
            style={{
                width: currentWidth-10,
                height,
                // border: '1px solid #ccc',
                position: 'absolute',
                // backgroundColor: '#f9f9f9',
                
            }}
           
            
            >
            {/* {children} */}
            <div
             className="col-resizer "
             style={{
                 position: 'absolute',
                 right: 0,
                 top: 0,
                 bottom: 0,
                 width: '40px',
                  
                 cursor: 'col-resize',
                 // backgroundColor: '#ddd',
                 display: 'flex',
                 alignItems: 'center',
                 justifyContent: 'end',
                 zIndex:1000,
                }}
                 onClick={(e)=>e.stopPropagation()}
                onMouseDown={handleMouseDown}
                >
               <FaGripLinesVertical color={"#666666ff"} />
            </div>
        </div>
                // </div>
    );
}
export default TableColumnResizer;